import React from 'react';
import toast from "react-hot-toast";
import ClientProjectSearchSelect from "../forms/selects/ClientProjectSearchSelect";
import { useReFileMailMutation } from "../../services/useremails";

export type EmailFilingProjectSelectProps = {
    mailId: string
    masterAccountId: string
    projectId: string | null
};

const EmailFilingProjectSelect = ({ mailId, masterAccountId, projectId }: Readonly<EmailFilingProjectSelectProps>) => {
    const [reFileMail, { isLoading, error }] = useReFileMailMutation();

    const handleOnChange = (v: any) => {
        toast.promise(reFileMail({ mailId, request: { masterAccountId, projectId: v?.value } }).unwrap(), {
            loading: 'Updating filed email project...',
            success: 'Email filed under the new project.',
            error: 'Unable to file email to project. Please try again later.'
        }).then(() => {});
    }

    return (
        <ClientProjectSearchSelect
            allowCreate={false}
            adviserId={""}
            divisionId={""}
            error={error}
            isClearable={!isLoading}
            isDisabled={isLoading}
            isMulti={false}
            label={null}
            masterAccountId={masterAccountId}
            onChange={handleOnChange}
            userId={""}
            value={projectId}
        />
    );
}

export default EmailFilingProjectSelect;